import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import TabPanel from "../../core/BaseComponents/TabPanel";
import CustomWelcomeMessageList from "../CustomWelcomeMessage/CustomWelcomeMessageList";
import DefaultWelcomeMessageList from "../DefaultWelcomeMessage/DefaultWelcomeMessageList";
import '../RailConfiguration/RailConfig.scss';
import './WelcomeMessageConfig.scss';
import { useSelector } from "react-redux";
import { useWelcomeMessageTemplates } from "./useWelcomeMessageTemplates";

function WelcomeMessageConfig() {
  const [value, setValue] = useState(0);
  const [listPageNo, setListPageNo] = useState(1);
  const { chainId } = useSelector((state) => state.chainIdReducer);
  const selectedChainId = chainId?.selectedChainId;
  const hotelName = chainId?.navSelectedhotelName?.at(0)?.name || "5555";
  const recordsPerPage = 10;

  const {
    templates,
    welcomeMessageList,
    totalPages,
    loading: templatesLoading,
    refetchList,
  } = useWelcomeMessageTemplates(selectedChainId, listPageNo, recordsPerPage);

  function a11yProps(index) {
    return {
      id: `welcome-message-tab-${index}`,
      "aria-controls": `welcome-message-tabpanel-${index}`,
      className: `eachtab ${value === index ? "Mui-selected" : ""}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 1) {
      refetchList();
    }
  };

  useEffect(() => {
    setValue(0);
    setListPageNo(1);
  }, [chainId]);

  return (
    <div className="pt-2 px-3 bg-white rounded-1">
      <Box className="boxroot welcome-message-tabs">
        <AppBar position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{
              hidden: true,
              style: { transition: "none" },
            }}
          >
            <Tab label="Custom Welcome Message" {...a11yProps(0)} />
            <Tab label="Default Welcome Message" {...a11yProps(1)} />
          </Tabs>
        </AppBar>

        <TabPanel value={value} index={0}>
          <CustomWelcomeMessageList templates={templates} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <DefaultWelcomeMessageList
            templates={templates}
            welcomeMessageList={welcomeMessageList}
            totalPages={totalPages}
            templatesLoading={templatesLoading}
            refetchList={refetchList}
            listPageNo={listPageNo}
            setListPageNo={setListPageNo}
            recordsPerPage={recordsPerPage}
            hotelName={hotelName}
          />
        </TabPanel>
      </Box>
    </div>
  );
}

export default WelcomeMessageConfig;
